import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getExtractionConfigurationsQueryKey } from "Configurations/Api/Queries/useExtractionConfigurationsQuery";
import {
	type UpdateExtractionConfigurationCommand,
	putExtractionConfiguration,
} from "Infrastructure/Api/Api";

export function useUpdateExtractionConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			id,
			command,
		}: { id: number; command: UpdateExtractionConfigurationCommand }) =>
			putExtractionConfiguration(id, command),
		onSuccess: () => {
			// Invalidate all extraction configuration queries regardless of pagination/search
			queryClient.invalidateQueries({
				predicate: (query) =>
					Array.isArray(query.queryKey) &&
					query.queryKey[0] === "EXTRACTION_CONFIGURATIONS_QUERY",
			});
		},
	});
}
